/**
 * function sorted array by id and returning latest element added to chart
 */
export function getLatestCartItem<T extends {id: string | number}>(cartItems?: T[]): T[] {
    if (!cartItems || !cartItems.length) return [];
    if (cartItems.length === 1) return cartItems;
    return [[...cartItems].sort((a, b) => Number(b.id) - Number(a.id))[0]];
}
